/* Nspire PDP pilot. Dispatch estimates only; does not touch cart or checkout. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    var boot = function () { api.init(root.document); };
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    root.document.addEventListener('shopify:section:load', boot);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var ZONE = 'Europe/Amsterdam';
  function neutralText(locale) {
    if (/^de(?:-|$)/i.test(locale || '')) return 'Der Versandzeitpunkt wird nach deiner Bestellung bestätigt.';
    if (/^fr(?:-|$)/i.test(locale || '')) return 'Le délai d’expédition sera confirmé après votre commande.';
    if (/^es(?:-|$)/i.test(locale || '')) return 'El plazo de envío se confirmará después de realizar el pedido.';
    return !locale || /^nl(?:-|$)/i.test(locale) ? 'De verzendtijd wordt bevestigd na je bestelling.' : 'Dispatch timing will be confirmed after you order.';
  }
  var formatter;
  function parts(date) {
    formatter = formatter || new Intl.DateTimeFormat('en-GB', {
      timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
    var result = {};
    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') result[part.type] = Number(part.value);
    });
    return result;
  }
  function key(date) { return date.toISOString().slice(0, 10); }
  // Convert the selected Amsterdam calendar day's 17:00 to an instant. Do not
  // add 24-hour multiples: the next workday can cross a DST change.
  function cutoffInstant(day) {
    var wall = Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), 17);
    var instant = wall;
    for (var i = 0; i < 3; i++) {
      var local = parts(new Date(instant));
      var offset = Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second) - instant;
      instant = wall - offset;
    }
    return instant;
  }
  function neutral(locale) {
    return { state: 'neutral', text: neutralText(locale), remainingSeconds: null, dispatchDate: null, cutoffAt: null };
  }
  // Strict validation is essential: Date normalizes impossible dates such as
  // February 30. Annual February 29 is valid and applies only in leap years.
  function validDate(value, annual) {
    if (typeof value !== 'string' || !(annual ? /^\d{2}-\d{2}$/ : /^\d{4}-\d{2}-\d{2}$/).test(value)) return false;
    var fields = value.split('-').map(Number);
    var year = annual ? 2000 : fields.shift();
    var month = fields[0], date = fields[1];
    if (year < 1 || year > 9999 || month < 1 || month > 12 || date < 1 || date > 31) return false;
    var day = new Date(0);
    day.setUTCFullYear(year, month - 1, date);
    day.setUTCHours(0, 0, 0, 0);
    return day.getUTCFullYear() === year && day.getUTCMonth() === month - 1 && day.getUTCDate() === date;
  }
  function validatedDates(values, annual) {
    if (values === undefined) values = [];
    if (!Array.isArray(values) || values.some(function (value) { return !validDate(value, annual); })) return null;
    return new Set(values);
  }
  // Confirmed operational closures, not every Dutch public holiday. Good
  // Friday and Liberation Day are not additional closures; other closures still apply.
  // Gregorian Easter (Meeus/Jones/Butcher); calculate for each candidate year.
  function confirmedDutchClosures(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    var easter = new Date(0);
    easter.setUTCFullYear(year, Math.floor(n / 31) - 1, n % 31 + 1);
    easter.setUTCHours(0, 0, 0, 0);
    var closures = new Set();
    function add(month, date) {
      var day = new Date(0);
      day.setUTCFullYear(year, month - 1, date);
      day.setUTCHours(0, 0, 0, 0);
      closures.add(key(day));
      return day;
    }
    add(1, 1);
    var kingsDay = add(4, 27);
    if (kingsDay.getUTCDay() === 0) {
      closures.delete(key(kingsDay));
      add(4, 26);
    }
    [1, 39, 50].forEach(function (offset) {
      var day = new Date(easter.getTime());
      day.setUTCDate(day.getUTCDate() + offset);
      closures.add(key(day));
    });
    add(12, 25);
    add(12, 26);
    return closures;
  }
  function dispatchText(day, isToday, locale, isTomorrow) {
    if (/^de(?:-|$)/i.test(locale || '')) {
      if (isToday) return 'Vor 17:00 Uhr bestellt = heute versendet';
      if (isTomorrow) return 'Heute bestellt = morgen versendet';
      return 'Heute bestellt = Versand am ' + ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'][day.getUTCDay()];
    }
    if (/^fr(?:-|$)/i.test(locale || '')) {
      if (isToday) return 'Commandez avant 17:00 = expédition aujourd’hui';
      if (isTomorrow) return 'Commandez aujourd’hui = expédition demain';
      return 'Commandez aujourd’hui = expédition ' + ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'][day.getUTCDay()];
    }
    if (/^es(?:-|$)/i.test(locale || '')) {
      if (isToday) return 'Pide antes de las 17:00 = envío hoy mismo';
      if (isTomorrow) return 'Pide hoy = envío mañana';
      return 'Pide hoy = envío el ' + ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'][day.getUTCDay()];
    }
    var dutch = !locale || /^nl(?:-|$)/i.test(locale);
    if (isToday) return dutch ? 'Voor 17:00 besteld = vandaag verzonden' : 'Ordered before 17:00 = dispatched today';
    if (isTomorrow) return dutch ? 'Vandaag besteld = morgen verzonden' : 'Ordered today = dispatched tomorrow';
    var weekdays = dutch ? ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'] :
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var weekday = weekdays[day.getUTCDay()];
    return dutch ? 'Vandaag besteld = ' + weekday + ' verzonden' : 'Ordered today = dispatched ' + weekday;
  }
  /**
   * Pure, host-time-zone independent calculation. An enabled estimate and safe
   * selected inventory are required for any promise. holidayCalendar opts in
   * to confirmed operational closures; omitted/empty/none keeps legacy behavior.
   * closedDates: YYYY-MM-DD; annualClosedDates: MM-DD and legacy exceptions
   * remain additional closures, including when the named calendar is enabled.
   */
  function calculateDispatch(input) {
    input = input || {};
    var now = input.now instanceof Date ? input.now : new Date(input.now);
    if (!input.selected || input.inventory_safe !== true || input.holidaysBlocked !== false || !Number.isFinite(now.getTime())) return neutral(input.locale);
    var holidayCalendar = input.holidayCalendar;
    if (holidayCalendar !== undefined && holidayCalendar !== '' && holidayCalendar !== 'none' && holidayCalendar !== 'nl_confirmed') return neutral(input.locale);
    var calendarYears = Object.create(null);
    var closedDates = validatedDates(input.closedDates, false);
    var annualClosedDates = validatedDates(input.annualClosedDates, true);
    var exceptions = validatedDates(input.exceptions, false);
    if (!closedDates || !annualClosedDates || !exceptions) return neutral(input.locale);
    exceptions.forEach(function (value) { closedDates.add(value); });
    var p = parts(now);
    var day = new Date(0);
    day.setUTCFullYear(p.year, p.month - 1, p.day);
    day.setUTCHours(0, 0, 0, 0);
    var today = key(day);
    var tomorrow = new Date(day.getTime());
    tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
    var seconds = p.hour * 3600 + p.minute * 60 + p.second;
    // At exactly 17:00 today's dispatch is no longer promised. Date arithmetic
    // advances calendar dates, not fixed 24-hour instants, across DST/year ends.
    if (seconds >= 17 * 3600) day.setUTCDate(day.getUTCDate() + 1);
    // Fail closed instead of looping indefinitely for a fully closed calendar.
    // A dispatch date more than ten years away is not a useful customer promise.
    var open = false;
    for (var searched = 0; searched < 3660; searched++) {
      if (day.getUTCFullYear() > 9999) return neutral(input.locale);
      var dateKey = key(day);
      var weekday = day.getUTCDay();
      var calendarClosed = false;
      if (holidayCalendar === 'nl_confirmed') {
        var year = day.getUTCFullYear();
        calendarYears[year] = calendarYears[year] || confirmedDutchClosures(year);
        calendarClosed = calendarYears[year].has(dateKey);
      }
      if (weekday !== 0 && weekday !== 6 && !calendarClosed && !closedDates.has(dateKey) && !annualClosedDates.has(dateKey.slice(5))) {
        open = true;
        break;
      }
      day.setUTCDate(day.getUTCDate() + 1);
    }
    if (!open) return neutral(input.locale);
    var dispatchDate = key(day);
    var isToday = dispatchDate === today;
    var cutoff = cutoffInstant(day);
    var remaining = Math.ceil((cutoff - now.getTime()) / 1000);
    if (!Number.isFinite(remaining) || remaining <= 0) return neutral(input.locale);
    return {
      state: isToday ? 'today' : (day.getUTCDay() === 1 ? 'monday' : 'next-day'),
      text: dispatchText(day, isToday, input.locale, dispatchDate === key(tomorrow)),
      remainingSeconds: remaining,
      dispatchDate: dispatchDate,
      cutoffAt: new Date(cutoff).toISOString()
    };
  }
  // Banner and CTA use the same calculated promise as the countdown target.
  function ctaText(result) { return result.text; }
  function bannerText(result) { return result.text; }
  function countdownParts(result) {
    var seconds = result.state !== 'neutral' && Number.isFinite(result.remainingSeconds) && result.remainingSeconds > 0 ? result.remainingSeconds : null;
    if (seconds === null) return { days: '--', hours: '--', minutes: '--', seconds: '--' };
    return {
      days: String(Math.floor(seconds / 86400)).padStart(2, '0'),
      hours: String(Math.floor(seconds % 86400 / 3600)).padStart(2, '0'),
      minutes: String(Math.floor(seconds % 3600 / 60)).padStart(2, '0'),
      seconds: String(seconds % 60).padStart(2, '0')
    };
  }
  function init(document) {
    document.querySelectorAll('[data-nspire-site-dispatch], [data-nspire-pilot]').forEach(function (wrapper) {
      if (wrapper.__nspireDispatchInitialized) return;
      var sitewide = wrapper.hasAttribute('data-nspire-site-dispatch');
      var banner = sitewide ? wrapper : wrapper.querySelector('[data-nspire-pilot-dispatch]');
      var source = wrapper.querySelector('[data-nspire-pilot-inventory]');
      if (!banner || (!sitewide && !source)) return;
      var inventory, exceptions, closedDates, annualClosedDates;
      try {
        inventory = sitewide ? {} : JSON.parse(source.textContent);
        exceptions = JSON.parse(banner.getAttribute('data-dispatch-exceptions') || '[]');
        closedDates = JSON.parse(banner.getAttribute('data-dispatch-closed-dates') || '[]');
        annualClosedDates = JSON.parse(banner.getAttribute('data-dispatch-annual-closed-dates') || '[]');
        if (!inventory || typeof inventory !== 'object' || Array.isArray(inventory) || !Array.isArray(exceptions) || !Array.isArray(closedDates) || !Array.isArray(annualClosedDates)) return;
      } catch (_) { return; } // Keep server-rendered neutral fallback intact.
      var view = document.defaultView;
      if (!view) return;
      var locale = banner.getAttribute('data-dispatch-locale') || 'nl';
      var dutch = /^nl(?:-|$)/i.test(locale);
      var isStack = banner.getAttribute('data-nspire-pilot-dispatch-stack') !== null;
      var clock = isStack && banner.querySelector('[data-dispatch-clock]');
      var message = isStack && banner.querySelector('[data-dispatch-message]');
      var unitNodes = isStack ? banner.querySelectorAll('[data-dispatch-unit]') : [];
      var motion = isStack && typeof view.matchMedia === 'function' ? view.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var reducedMotion = Boolean(motion && motion.matches);
      var clockVisible = false;
      var canRotate = false;
      var relocated = false;
      var cleaned = false;
      var activeAnimation = null;
      var animationGeneration = 0;
      var pendingClockVisible = null;
      // Move only this pilot-owned node, outside the native header group. The
      // theme retains its own header height, sticky state, menu and cart wiring.
      if (isStack && !sitewide && typeof document.querySelector === 'function') {
        var headerGroup = document.querySelector('#header-group');
        if (headerGroup && headerGroup.parentNode) {
          headerGroup.parentNode.insertBefore(banner, headerGroup);
          relocated = true;
        }
      }
      function selectedId() {
        var fields = wrapper.querySelectorAll('.buy-buttons-block form[action*="/cart/add"] [name="id"]');
        if (!fields.length) fields = wrapper.querySelectorAll('form[action*="/cart/add"] [name="id"]');
        for (var i = 0; i < fields.length; i++) {
          var field = fields[i];
          if (field.disabled || ((field.type === 'radio' || field.type === 'checkbox') && !field.checked)) continue;
          if (field.value && Object.prototype.hasOwnProperty.call(inventory, String(field.value))) return String(field.value);
        }
        return null;
      }
      // Keep the intended variant as a constraint even after the fetch settles.
      // An older async response must not revive a promise for a different choice.
      var hasIntent = false;
      var intendedId = null;
      var awaitingVariant = false;
      function captureChoice(event) {
        var target = event && event.target;
        if (!target || !target.closest || !target.closest('variant-picker')) return;
        var option = target.tagName === 'SELECT' ? target.options[target.selectedIndex] : target;
        hasIntent = true;
        awaitingVariant = true;
        intendedId = option && option.dataset && option.dataset.variantId ? String(option.dataset.variantId) : null;
        refresh();
      }
      function nativeSelected() {
        awaitingVariant = true;
        refresh();
      }
      function nativeUpdated(event) {
        var updatedId = event && event.detail && event.detail.resource && event.detail.resource.id;
        // The selected option may have no valid variant; remain neutral then.
        if (hasIntent && intendedId !== null && String(updatedId) === intendedId) awaitingVariant = false;
        refresh();
      }
      function renderCopies(result) {
        wrapper.querySelectorAll('[data-nspire-pilot-dispatch-copy]').forEach(function (copy) {
          var text = ctaText(result, locale);
          if (copy.textContent !== text) copy.textContent = text;
          copy.setAttribute('data-dispatch-state', result.state);
        });
      }
      function renderRotation() {
        if (!message || !clock) return;
        message.hidden = clockVisible;
        message.setAttribute('aria-hidden', String(clockVisible));
        clock.hidden = !clockVisible;
        clock.setAttribute('aria-hidden', String(!clockVisible));
        banner.setAttribute('data-message-index', clockVisible ? '1' : '0');
      }
      function paint(result) {
        // Deliberately no live region: second-by-second announcements are noisy.
        banner.setAttribute('aria-live', 'off');
        banner.setAttribute('data-dispatch-state', result.state);
        if (isStack && message && clock) {
          var text = bannerText(result, locale);
          if (message.textContent !== text) message.textContent = text;
          var values = countdownParts(result);
          unitNodes.forEach(function (node) {
            var value = values[node.getAttribute('data-dispatch-unit')];
            if (node.textContent !== value) node.textContent = value;
          });
          var active = values.days !== '--';
          canRotate = active;
          // Unsafe inventory, unresolved variants or invalid calendar data must
          // immediately replace either slide (even mid-animation) with fallback.
          if (!active) {
            if (activeAnimation || pendingClockVisible !== null) cancelTransition(false);
            clockVisible = false;
          }
          clock.setAttribute('data-countdown-active', String(active));
          clock.setAttribute('data-countdown-target', active ? result.cutoffAt : '');
          clock.setAttribute('data-dispatch-date', active ? result.dispatchDate : '');
          clock.setAttribute('aria-label', /^es(?:-|$)/i.test(locale) ?
            (active ? 'Tiempo hasta la hora límite de envío el ' + result.dispatchDate + ' a las 17:00 en Ámsterdam: ' +
              values.days + (Number(values.days) === 1 ? ' día, ' : ' días, ') +
              values.hours + (Number(values.hours) === 1 ? ' hora, ' : ' horas, ') +
              values.minutes + (Number(values.minutes) === 1 ? ' minuto, ' : ' minutos, ') +
              values.seconds + (Number(values.seconds) === 1 ? ' segundo.' : ' segundos.') :
              'No hay una cuenta atrás de envío activa. ' + result.text) : active ?
            (dutch ? 'Tijd tot de verzendgrens op ' + result.dispatchDate + ' om 17:00 in Amsterdam: ' : 'Time until the dispatch cutoff on ' + result.dispatchDate + ' at 17:00 in Amsterdam: ') + values.days + (dutch ? ' dagen, ' : ' days, ') + values.hours + (dutch ? ' uur, ' : ' hours, ') + values.minutes + (dutch ? ' minuten, ' : ' minutes, ') + values.seconds + (dutch ? ' seconden.' : ' seconds.') :
            (dutch ? 'Geen actieve verzendcountdown. ' : 'No active dispatch countdown. ') + result.text);
          if (/^de(?:-|$)/i.test(locale)) clock.setAttribute('aria-label', active ?
            'Zeit bis zum Versandschluss am ' + result.dispatchDate + ' um 17:00 in Amsterdam: ' +
            values.days + (Number(values.days) === 1 ? ' Tag, ' : ' Tage, ') +
            values.hours + (Number(values.hours) === 1 ? ' Stunde, ' : ' Stunden, ') +
            values.minutes + (Number(values.minutes) === 1 ? ' Minute, ' : ' Minuten, ') +
            values.seconds + (Number(values.seconds) === 1 ? ' Sekunde.' : ' Sekunden.') : 'Kein aktiver Versandcountdown. ' + result.text);
          if (/^fr(?:-|$)/i.test(locale)) clock.setAttribute('aria-label', active ?
            'Temps restant avant la limite d’expédition le ' + result.dispatchDate + ' à 17:00 à Amsterdam : ' +
            values.days + (Number(values.days) === 1 ? ' jour, ' : ' jours, ') +
            values.hours + (Number(values.hours) === 1 ? ' heure, ' : ' heures, ') +
            values.minutes + (Number(values.minutes) === 1 ? ' minute, ' : ' minutes, ') +
            values.seconds + (Number(values.seconds) === 1 ? ' seconde.' : ' secondes.') : 'Aucun compte à rebours d’expédition actif. ' + result.text);
          renderRotation();
        } else if (banner.textContent !== result.text) banner.textContent = result.text;
        renderCopies(result);
      }
      function render() {
        if (!wrapper.isConnected) { cleanup(); return; }
        try {
          var id = selectedId();
          var record = id && Object.prototype.hasOwnProperty.call(inventory, id) ? inventory[id] : null;
          paint(calculateDispatch({
            now: new Date(), selected: sitewide || (Boolean(id) && !awaitingVariant && (!hasIntent || (intendedId !== null && id === intendedId))),
            locale: locale,
            inventory_safe: sitewide || record === true || Boolean(record && record.inventory_safe === true),
            holidaysBlocked: banner.getAttribute('data-holidays-blocked') !== 'false',
            holidayCalendar: banner.getAttribute('data-dispatch-holiday-calendar') || '',
            exceptions: exceptions, closedDates: closedDates, annualClosedDates: annualClosedDates
          }));
        } catch (_) {
          // Intl or runtime failure must never leave a stale dispatch promise.
          paint(neutral(locale));
        }
      }
      var deferred;
      function refresh() {
        render();
        view.clearTimeout(deferred);
        if (!cleaned) deferred = view.setTimeout(render, 0); // Let theme variant handlers settle.
      }
      function visible() { if (!document.hidden) refresh(); }
      function cancelTransition(commit) {
        animationGeneration += 1;
        if (activeAnimation) {
          activeAnimation.onfinish = null;
          activeAnimation.cancel();
          activeAnimation = null;
        }
        if (commit && pendingClockVisible !== null) clockVisible = pendingClockVisible;
        pendingClockVisible = null;
        banner.setAttribute('data-message-transition', 'idle');
        if (commit && !cleaned) render();
      }
      function rotate() {
        if (!wrapper.isConnected) { cleanup(); return; }
        if (document.hidden || activeAnimation) return;
        // Recheck before choosing slides: the cutoff, variant or calendar may
        // have changed since the last tick. Neutral fallback never rotates.
        render();
        if (cleaned || !canRotate) return;
        var outgoing = clockVisible ? clock : message;
        var incoming = clockVisible ? message : clock;
        // Older browsers and reduced-motion users retain an immediate safe swap.
        if (!outgoing || !incoming || typeof outgoing.animate !== 'function' || reducedMotion) {
          clockVisible = !clockVisible;
          render();
          return;
        }
        // The fixed-height shared grid prevents movement between alternatives.
        pendingClockVisible = !clockVisible;
        var generation = ++animationGeneration;
        banner.setAttribute('data-message-transition', 'exit');
        activeAnimation = outgoing.animate([
          { transform: 'translateX(0)', opacity: 1 },
          { transform: 'translateX(110%)', opacity: 0 }
        ], { duration: 200, easing: 'ease-in', fill: 'forwards' });
        activeAnimation.onfinish = function () {
          if (cleaned || generation !== animationGeneration) return;
          activeAnimation.onfinish = null;
          // No overlap: the next message becomes visible only after exit ends.
          clockVisible = pendingClockVisible;
          render();
          if (cleaned || generation !== animationGeneration) return;
          activeAnimation.cancel();
          banner.setAttribute('data-message-transition', 'enter');
          activeAnimation = incoming.animate([
            { transform: 'translateX(-110%)', opacity: 0 },
            { transform: 'translateX(0)', opacity: 1 }
          ], { duration: 240, easing: 'ease-out', fill: 'forwards' });
          activeAnimation.onfinish = function () {
            if (cleaned || generation !== animationGeneration) return;
            cancelTransition(true);
          };
        };
      }
      function motionChanged(event) {
        reducedMotion = Boolean(event.matches);
        if (reducedMotion && activeAnimation) cancelTransition(true);
      }
      function sectionUnloaded(event) {
        if (!wrapper.isConnected || (event.target && typeof event.target.contains === 'function' && event.target.contains(wrapper))) cleanup();
      }
      var events = ['variant:change', 'variant:changed', 'product:variant-change', 'variant:update'];
      function cleanup() {
        if (cleaned) return;
        cleaned = true;
        cancelTransition(false);
        view.clearInterval(timer);
        view.clearInterval(rotationTimer);
        view.clearTimeout(deferred);
        wrapper.removeEventListener('variant:selected', nativeSelected);
        wrapper.removeEventListener('variant:update', nativeUpdated);
        wrapper.removeEventListener('change', captureChoice, true);
        wrapper.removeEventListener('change', refresh);
        wrapper.removeEventListener('input', refresh);
        events.forEach(function (name) { document.removeEventListener(name, refresh); });
        document.removeEventListener('visibilitychange', visible);
        document.removeEventListener('shopify:section:unload', sectionUnloaded);
        view.removeEventListener('pageshow', refresh);
        if (isStack) {
          if (motion && typeof motion.removeEventListener === 'function') motion.removeEventListener('change', motionChanged);
          if (relocated && banner.parentNode) banner.parentNode.removeChild(banner);
        }
        wrapper.__nspireDispatchInitialized = false;
      }
      wrapper.__nspireDispatchInitialized = true;
      wrapper.addEventListener('variant:selected', nativeSelected);
      wrapper.addEventListener('variant:update', nativeUpdated);
      wrapper.addEventListener('change', captureChoice, true);
      wrapper.addEventListener('change', refresh);
      wrapper.addEventListener('input', refresh);
      events.forEach(function (name) { document.addEventListener(name, refresh); });
      document.addEventListener('visibilitychange', visible);
      document.addEventListener('shopify:section:unload', sectionUnloaded);
      view.addEventListener('pageshow', refresh);
      var rotationTimer;
      if (isStack) {
        if (motion && typeof motion.addEventListener === 'function') motion.addEventListener('change', motionChanged);
        // The text and four-box clock alternate within one banner.
        if (message && clock) rotationTimer = view.setInterval(rotate, 4000);
      }
      var timer = view.setInterval(function () {
        if (!wrapper.isConnected) { cleanup(); return; }
        if (!document.hidden) render();
      }, 1000);
      render();
    });
  }
  return { calculateDispatch: calculateDispatch, init: init, ctaText: ctaText, bannerText: bannerText, countdownParts: countdownParts, timeZone: ZONE };
});





